import { AppThunk } from 'reducers/index';

// Selectors
import { getCardTemplateLayoutUuid } from 'cards/selectors/reversePrintingLayouts';
import { getActiveVariationUUID, getActiveSelectionSize } from 'cards/reducers/pdp/selectors';
import {
  getCardType,
  getCustomizationTypeUUIDs,
  getProjectType,
} from 'cards/selectors/cardProjectSelector';

// Constants
import { LAYOUTS, ReversePrintingLayoutsState } from 'cards/reducers/reversePrintingLayouts';
import ApiService from '../../util/api';

// Actions
export const UPDATE_LAYOUTS_STATE = 'cards/actions/reversePrintingLayouts/UPDATE_LAYOUTS';

interface UpdateLayoutsState {
  type: typeof UPDATE_LAYOUTS_STATE;
  payload: Partial<ReversePrintingLayoutsState>;
}

export const updateLayoutsState = (
  payload: Partial<ReversePrintingLayoutsState>
): ReversePrintingLayoutsAction => ({
  type: UPDATE_LAYOUTS_STATE,
  payload,
});

export const fetchLayouts = (): AppThunk<any> => (dispatch, getState) => {
  const cardType = getCardType(getState());
  const size = getActiveSelectionSize(getState());
  const variationUuid = getActiveVariationUUID(getState());

  if (!cardType || !size || !variationUuid) return Promise.resolve(null);

  dispatch(updateLayoutsState({ loading: true }));

  return ApiService.get(
    `/web-api/v2/card-template/card-template-layout/${cardType}/${size}/${variationUuid}`
  ).then(result => {
    return dispatch(
      updateLayoutsState({ layouts: result.layouts, loading: false, uuid: result.uuid })
    );
  });
};

export const updateSelectedLayout = (
  cardTemplateLayoutContentUuid: string,
  selected: LAYOUTS[],
  pageUuid: string
): AppThunk<any> => (dispatch, getState) => {
  const cardTemplateLayoutUuid = getCardTemplateLayoutUuid(getState());
  const cardType = getProjectType(getState());
  const customizationTypeUuids = getCustomizationTypeUUIDs(getState());
  const customizationUuid = customizationTypeUuids[cardType];

  const requestBody = {
    card_template_layout_uuid: cardTemplateLayoutUuid,
    card_template_layout_content_uuid: cardTemplateLayoutContentUuid,
  };

  ApiService.put(
    `/web-api/v2/card-project/customization/${customizationUuid}/page/${pageUuid}/update-customization-page-template-layout`,
    requestBody
  );

  return dispatch(updateLayoutsState({ selected }));
};

export type ReversePrintingLayoutsAction = UpdateLayoutsState;
